import { inject } from '@vercel/analytics';
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from 'App';
import 'index.css';
import reportWebVitals from 'reportWebVitals';
import { sendToVercelAnalytics } from 'vitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// Vercel Analytics only works when the app is hosted on Vercel. On any other
// host (localhost, acnconnect.ca, etc.) the injected `/_vercel/insights/script.js`
// request is served index.html and the browser throws
// "SyntaxError: Unexpected token '<'". Only enable it on a Vercel domain.
const isVercelHost =
  typeof window !== "undefined" &&
  /(^|\.)vercel\.app$/.test(window.location.hostname);
if (isVercelHost) {
  inject();
  reportWebVitals(sendToVercelAnalytics);
}
